/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WeeklyAvailability = {
    OneDayPerWeek: 'ONE_DAY_PER_WEEK',
    TwoDaysPerWeek: 'TWO_DAYS_PER_WEEK',
    ThreeDaysPerWeek: 'THREE_DAYS_PER_WEEK',
    FourDaysPerWeek: 'FOUR_DAYS_PER_WEEK',
    FullTime: 'FULL_TIME'
} as const;
export type WeeklyAvailability = typeof WeeklyAvailability[keyof typeof WeeklyAvailability];


export function instanceOfWeeklyAvailability(value: any): boolean {
    for (const key in WeeklyAvailability) {
        if (Object.prototype.hasOwnProperty.call(WeeklyAvailability, key)) {
            // @ts-ignore
            if (WeeklyAvailability[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WeeklyAvailabilityFromJSON(json: any): WeeklyAvailability {
    return WeeklyAvailabilityFromJSONTyped(json, false);
}

export function WeeklyAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeeklyAvailability {
    return json as WeeklyAvailability;
}

export function WeeklyAvailabilityToJSON(value?: WeeklyAvailability | null): any {
    return value as any;
}

